import { inChinaIcpHost } from '../utils/pathHelper';
import { navWithGaEvent } from '../utils/trackingHelper';
import { initGtag, gtagSetAnalyticsId } from './gtag';
import { initMaruge, initKanjiwariMaruge } from './affiliate/maruge';
import trackItemPurchased from './trackItemPurchased';
import trackElementTapped from './trackElementTapped';
import trackPageView from './trackPageView';
import trackRegistrationCompleted from './trackRegistrationCompleted';
import trackCampaign from './trackCampaign';
import trackAffiliate from './trackAffiliate';
import { twitterTrack } from './twitter';
import cookies from 'browser-cookies';
import { initBraze, logViewArticle, setBrazeOptions } from './braze';

/**
 * turbolinks:load 以前にもGAイベント送るために、analytics idをセットする
 * 最初のgtag() 呼び出しの前にここを実行することが必要。現在は defer scriptの順番で実行順番を保証する
 */
gtagSetAnalyticsId();

document.addEventListener('turbolinks:load', () => {
  initGtag();
  if (inChinaIcpHost()) {
    // 中国からはマルジュ / Facebook のJS読み込みがJSブロッキングするため読み込まない
  } else {
    initMaruge();
    const brazeInitialized = initBraze();
    if (brazeInitialized) {
      setBrazeOptions();
    }
  }

  // ---------------------------------------------
  // data-track-element-tapped属性を持つエレメント
  // ---------------------------------------------
  Array.from(document.querySelectorAll('[data-track-element-tapped]')).forEach((element) => {
    element.addEventListener('click', (event) => {
      trackElementTapped(event.currentTarget);
    });
  });

  // ---------------------------------------------
  // すべてのページ
  // ---------------------------------------------

  try {
    trackPageView();
    trackRegistrationCompleted();
    trackCampaign(); 
    trackAffiliate();
  } catch (error) {
    console.error('Error in tracking:', error);
  }
  // ---------------------------------------------
  // 各ページ
  // ---------------------------------------------
  const path: string = document.location.pathname;

  // 購入完了ページ
  // trackItemPurchased は今の所 initMaruge が必要。
  // 単体では使用できないので注意。
  if (path.match(/^\/snow\/items\/\d+\/orders\/.+\/thankyou/) ||
      path.match(/^\/snow\/accommodations\/(.+)\/plans\/(.+)\/order\/thankyou/) ||
      path.match(/^\/snow\/insurance\/.+\/order\/.+\/thankyou/) ||
      path.match(/^\/snow\/me\/payment\/\d{1,}/) ||
      path.match(/^\/snow\/stay-packages\/payment$/)
  ) {
    trackItemPurchased();
  }

  // 紹介キャンペーンLP
  if (path.match(/^\/snow\/referral_campaign/)){
    twitterTrack();
  }

  if (path.match(/^\/snow\/auth\/session/)){
    if (cookies.get('new_user') === '1') {
      twitterTrack();
    }
  }

  // 記事ページ
  if (path.match(/^\/snow\/articles\/[1-9]\d*$/)) {
    logViewArticle();
  }


  // ログアウト
  const signOutButton: HTMLElement = document.querySelector('.js-sign-out');
  if (signOutButton) {
    signOutButton.onclick = (e: MouseEvent) => {
      const target = (e.target as HTMLAnchorElement);
        target.href = '/snow/auth/session';
        signOutButton.onclick = null;
        target.click();
    };
  }
});

(window as any).navWithGaEvent = navWithGaEvent;
